import { IntegrationType } from '@kcftech/prometheustypescriptapiclient';

export const IntegrationMaxChar = 500;
export const IntegrationAuthMaxChar = 1024;
export const DefaultIntegrationType = IntegrationType.Cmms;
